// src/api/assetAssignApi.js
import apiClient from './axios';

const assetAssignApi = {
  // GET all asset assignments (requests)
  getAll: async (page = 1, pageSize = 10, search = '') => {
    const response = await apiClient.get('/asset-assigns/', {
      params: { page, page_size: pageSize, search },
    });
    return response.data;
  },

  // CREATE new asset request
  create: async (data) => {
    const response = await apiClient.post('/asset-assigns/', data);
    return response.data;
  },

  // UPDATE existing request
  update: async (id, data) => {
    const response = await apiClient.patch(`/asset-assigns/${id}/`, data);
    return response.data;
  },

  // DELETE request
  delete: async (id) => {
    await apiClient.delete(`/asset-assigns/${id}/`);
    return id;
  },

  // acknowledge
    acknowledge: async (id, data) => {
    await apiClient.post(`/asset-assigns/${id}/acknowledge/`, data);
  },


  // Fetch available IT stock items (for dropdown)
  getStockItems: async () => {
    const response = await apiClient.get('/stocks/it/');
    return response.data; // array of stock items
  },

  // RETURN ASSET
 returnAsset: async (id) => {
    const response = await apiClient.post(`/asset-assigns/${id}/return/`);
    return response.data;
  },
};

export default assetAssignApi;